// extracted by mini-css-extract-plugin
export default {"content":"page-content_content__0-gMW","large":"page-content_large__9MBgJ","max":"page-content_max__QNO2j"};